export default {
  flock_copyright: 'Flock FZ LLC',
  read_release_notes: 'Read release notes',
};
